/* unplugin-vue-components disabled */import script from "./index-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./index-banner.vue?vue&type=script&setup=true&lang=ts"

import "./index-banner.vue?vue&type=style&index=0&id=51d29bd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d29bd6"]])

export default __exports__